import axios from "axios";
import { Toast } from 'vant'; 

// import store from '../store';
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

const apiOrigin = process.env.VUE_APP_API_ORIGIN || ''
const baseApi = process.env.VUE_APP_BASE_API || '/api/v1'
const baseURL = apiOrigin + baseApi

// 创建axios实例
const service = axios.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分
    baseURL,
    
    // 超时
    timeout: 20000
})


// request拦截器
service.interceptors.request.use(config => {

  if((config.url+"").indexOf("saveStudyTime")<0){
    Toast.loading({
      duration:0,
      message: 'Loading...',
      forbidClick: true,
      loadingType: 'spinner',
    });
  }
 
    // 是否需要设置 token
    const token =localStorage.getItem("token")
    config.headers['Authorization'] =  token // 让每个请求携带自定义token 请根据实际情况自行修改
    // get请求映射params参数
    if (config.method === 'get' && config.params) {
      let url = config.url + '?';
      for (const propName of Object.keys(config.params)) {
        const value = config.params[propName];
        var part = encodeURIComponent(propName) + "=";
        if (value !== null && typeof(value) !== "undefined") {
          if (typeof value === 'object') {
            for (const key of Object.keys(value)) {
              if (value[key] !== null && typeof (value[key]) !== 'undefined') {
                let params = propName + '[' + key + ']';
                let subPart = encodeURIComponent(params) + '=';
                url += subPart + encodeURIComponent(value[key]) + '&';
              }
            }
          } else {
            url += part + encodeURIComponent(value) + "&";
          }
        }
      }
      url = url.slice(0, -1);
      config.params = {};
      config.url = url;
    }
    return config
  }, error => {
    //store.commit('hideLoading')
    Toast.clear()
    console.log(error)
    Promise.reject(error)
  })
  
  // 响应拦截器
  service.interceptors.response.use(res => {
    //store.commit('hideLoading')
    Toast.clear()
    //console.log(res)
      // 未设置状态码则默认成功状态
      const code = res.code || 200;
      console.log('code:'+code)
      // 获取错误信息
      const msg =  res.data.message || 'server error'
      if (code === 445 ) {
        Toast({
          message: "异地登陆",
          duration: 1000,
          forbidClick: true
        });
           console.log('---401')
      }else if (code === 500) {
        Toast({
            message: msg,
            duration: 1000,
            forbidClick: true
        });
        return Promise.reject(new Error(msg))
      } else if (code !== 200) {
        Toast({
          message: msg,
          duration: 1000,
          forbidClick: true
        });
        return Promise.reject('error')
      } else {
        if(code==200) {
          if(res.data.code==445) {
            localStorage.removeItem('token')
            window.location.href = '/login'
          }

          if(res.data.code==444) {
            window.location.href = '/login'
          }
        }
        return res.data
      }
    },
    error => {
      //store.commit('hideLoading')
      Toast.clear()
      console.log('err' + error)
      let { message } = error;
      if (message == "Network Error") {
        message = "Network Error";
      }
      else if (message.includes("timeout")) {
        message = "request timeout";
      }
      else if (message.includes("Request failed with status code")) {
        message = "system api " + message.substr(message.length - 3) + " error";
      }
      Toast({
        message: message,
        duration: 1000,
        forbidClick: true
      });
      return Promise.reject(error)
    }
  )


export default service
